<template>
    <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    class="demo-ruleForm"
    size="large"
    style="height: 410px;"
    status-icon>
        <el-form-item label="页面标注" prop="title" class="title">
            <el-input
            v-model="ruleForm.title"
            placeholder="请输入页面标注"
            ></el-input>
        </el-form-item>
        <el-form-item
          label="背景图"
          prop="url"
        >
        &nbsp;&nbsp;&nbsp;&nbsp;
            <ImgUpload
            :type="2"
            :limit="1"
            ref="backgroundImg"
            :imagePath="ruleForm.url"
            @change-image="changeImage"
            ></ImgUpload>
        </el-form-item>
    </el-form>
    <div slot="footer" class="from_btn button">
        <el-button @click="onCancel" size="large">取消</el-button>
        <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
        :disabled = "submitDisabled">提交保存</el-button>
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>
</template>

<script>
import {
    editBackgroundImage,
    addBackgroundImage,
} from "network/focusFigure.js";
import ImgUpload from "components/ImgUploadNew.vue";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
    name: "AddEditBackground",
    components: {
        ImgUpload
    },
    emits: {
        "close-dialog": null,
        "update-list": null,
    },
    props: {
        editId: {
            type: Number,
            default: 0,
        },
        imgObj: Object,
    },
    setup(props, { emit }) {
        const data = reactive({
            loading: false,
            ruleForm: {
                id: 0,
                title: "",
                url: "",
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请填写页面标注",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (
                                data.ruleForm.title === "" ||
                                data.ruleForm.title === undefined ||
                                data.ruleForm.title === null
                            ) {
                                callback(new Error("请填写页面标注"));
                            } else {
                                callback();
                            }
                        },
                    }
                ],
                url: [
                    {
                        required: true,
                        message: "请上传背景图",
                        trigger: "change",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (
                                data.ruleForm.url === "" ||
                                data.ruleForm.url === undefined ||
                                data.ruleForm.url === null
                            ) {
                                callback(new Error("请上传背景图"));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
            },
            submitDisabled:false
        });


        //编辑请求院校详情
        if (props.imgObj && props.editId > 0) {
            data.ruleForm = props.imgObj;
        } else {
        }
        
        const ruleFormRef = ref();
        const backgroundImg = ref();

        const onCancel = () => {
            emit("close-dialog");
            ruleFormRef.value.resetFields();
            // 关闭弹窗 判断图片删除
            if (backgroundImg.value) {
                backgroundImg.value.cancelData();
            }
        };

        //获取图片上传组件传过来的
        const changeImage = (arr) => {
            if (arr && arr.length > 0) {
                data.ruleForm.url = arr[0].url;
                ruleFormRef.value.clearValidate("url");
            } else {
                data.ruleForm.url = "";
            }
        };

        const submitForm = async () => {
            const form = unref(ruleFormRef);
            if (!form) return;
            try {
                const valid = await form.validate();
                if (!valid) {
                    return false;
                } else {
                    data.submitDisabled=true;
                    updataAdd(data.ruleForm).then(() => {
                        data.submitDisabled = false;
                    });
                }
            } catch (error) {
                ElMessage.error("有必填内容未填写！");
                console.log(error);
            }
        };

        const updataAdd = async (val) => {
            data.loading = true;
            let result = "";
            if (props.editId > 0) {
                var obj ={
                    id : props.editId,
                    title : val.title,
                    url : val.url
                }
                result = await editBackgroundImage(obj);
            } else {
                result = await addBackgroundImage(val);
            }
            if (result && result.code == 1) {
                data.loading = false;
                ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
                confirmButtonText: "确定",
                });
                if (backgroundImg.value) {
                    backgroundImg.value.submitData(data.ruleForm.url);
                }
                emit("close-dialog");
                emit("update-list");
            } else {
                data.loading = false;
                ElMessageBox.alert(result.message, props.isEdit ? "编辑" : "添加", {
                confirmButtonText: "确定",
                });
            }
        }


        return {
        ...toRefs(data),
        ruleFormRef,
        backgroundImg,
        onCancel,
        changeImage,
        submitForm,
        updataAdd,
        };
    }
}
</script>

<style scoped>
.button{
}
</style>